// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svY1b.ui.dropdown{display:inline-block}.svY1b.ui.dropdown .akKb2.menu{background-color:var(--anchore-color-gray-0)}:root[data-darkreader-scheme=dark] .svY1b.ui.dropdown .akKb2.menu{background-color:var(--anchore-color-gray-100)}.svY1b.ui.dropdown .akKb2.menu .item{font-size:1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `svY1b`,
	"menu": `akKb2`
};
module.exports = ___CSS_LOADER_EXPORT___;
